import { useNavigate } from 'react-router'
import { ACCOUNT_PAGE } from '../../configuration/paths'
import useIsMobile from '../../hooks/useIsMobile'

// Renders children on tablet/desktop; on phones shows a "use a larger screen" notice.
// For admin pages that aren't practical on a phone (Management, RAD Dashboard).
export const DesktopOnly = ({ pageName = 'This page', children }) => {
  const isMobile = useIsMobile()
  const navigate = useNavigate()
  if (!isMobile) return children
  return (
    <div style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: 24, gap: 14 }}>
      <div style={{ fontSize: 40 }}>🖥️</div>
      <h2 style={{ color: 'var(--rz-ink)', margin: 0 }}>{pageName} works best on a larger screen</h2>
      <p style={{ color: 'var(--rz-muted)', maxWidth: 320 }}>
        Please open this page on a desktop or tablet for the full experience.
      </p>
      <button onClick={() => navigate(ACCOUNT_PAGE)}
        style={{ background: 'var(--rz-primary)', color: '#fff', border: 'none',
          borderRadius: 'var(--rz-radius)', padding: '10px 18px', fontWeight: 700, cursor: 'pointer' }}>
        Back to Dashboard
      </button>
    </div>
  )
}

export default DesktopOnly
